import DVCore, { BaseAPI } from "./core/DVCore";

const UsersAPI = BaseAPI("/api/users/");

/**
 * Get active user information
 * @param {*} onUser - callback
 * @param {*} onNoUser - callback
 * @param {*} onError -callback (Optional)
 */
UsersAPI.me = (onUser, onNoUser, onError = null) => {
    let url = UsersAPI.baseURL + "me";
    return DVCore.get(url, null, onUser, onNoUser, onError);
};

UsersAPI.updatePreferences = (prefs, onSuccess, onFail, onError = null) => {
    let url = UsersAPI.baseURL + "me/preferences";
    return DVCore.put(url, prefs, onSuccess, onFail, onError);
};

export default UsersAPI;